import styled from 'styled-components';

import {
  Card as SemanticCard,
  Dimmer as SemanticDimmer,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent, Button as ButtonLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled(SemanticDimmer)``;

export const Content = styled(SemanticCard)`
  &&& {
    padding: 20px;
    width: 600px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
`;

export const ConfirmButton = styled(ButtonLayoutComponent)`
  width: 200px;
`;

export const CancelButton = styled(ButtonLayoutComponent.Inverted)`
  width: 200px;
`;

export const Title = styled(TextLayoutComponent.Header)`
  text-align: left;
  margin-bottom: 10px;
`;

export const Text = styled(TextLayoutComponent)`
  text-align: left;
  margin-bottom: 10px;
`;
